// extracted by mini-css-extract-plugin
export default {"modalBody":"QcFenOXBFRZz0bIDCOzv","modalWrap":"leVvWCsXxGP03qSSSqE5","recruiterCard":"MM2GQ_AGe3NSD8Z2YtDd","ant-modal-content":"ZIuPdplieNnfMs4BxbjI"};